import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

const calendarApi = {
  // Get all calendars for a group
  getCalendars: async (groupId) => {
    const response = await axios.get(`${API_BASE_URL}/groups/${groupId}/calendars`, {
      withCredentials: true
    });
    return response.data;
  },

  // Get a single calendar
  getCalendar: async (groupId, calendarId) => {
    const response = await axios.get(`${API_BASE_URL}/groups/${groupId}/calendars/${calendarId}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Create a new calendar
  createCalendar: async (groupId, calendarData) => {
    const response = await axios.post(`${API_BASE_URL}/groups/${groupId}/calendars`, calendarData, {
      withCredentials: true
    });
    return response.data;
  },

  // Update a calendar
  updateCalendar: async (groupId, calendarId, calendarData) => {
    const response = await axios.put(`${API_BASE_URL}/groups/${groupId}/calendars/${calendarId}`, calendarData, {
      withCredentials: true
    });
    return response.data;
  },

  // Delete a calendar
  deleteCalendar: async (groupId, calendarId) => {
    const response = await axios.delete(`${API_BASE_URL}/groups/${groupId}/calendars/${calendarId}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Link an event to a calendar
  linkEventToCalendar: async (groupId, calendarId, eventId) => {
    const response = await axios.post(`${API_BASE_URL}/groups/${groupId}/calendars/${calendarId}/events/${eventId}`, {}, {
      withCredentials: true
    });
    return response.data;
  },

  // Unlink an event from a calendar
  unlinkEventFromCalendar: async (groupId, calendarId, eventId) => {
    const response = await axios.delete(`${API_BASE_URL}/groups/${groupId}/calendars/${calendarId}/events/${eventId}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Link a class to a calendar
  linkClassToCalendar: async (groupId, calendarId, classId) => {
    const response = await axios.post(`${API_BASE_URL}/groups/${groupId}/calendars/${calendarId}/classes/${classId}`, {}, {
      withCredentials: true
    });
    return response.data;
  },

  // Link a calendar item to a calendar
  linkItemToCalendar: async (groupId, calendarId, itemId) => {
    const response = await axios.post(`${API_BASE_URL}/groups/${groupId}/calendars/${calendarId}/items/${itemId}`, {}, {
      withCredentials: true
    });
    return response.data;
  },

  // Batch link an item to multiple calendars
  linkItemToCalendars: async (groupId, itemId, itemType, calendarIds) => {
    const promises = calendarIds.map(calendarId => {
      switch (itemType) {
        case 'event':
          return calendarApi.linkEventToCalendar(groupId, calendarId, itemId);
        case 'class':
          return calendarApi.linkClassToCalendar(groupId, calendarId, itemId);
        case 'item':
          return calendarApi.linkItemToCalendar(groupId, calendarId, itemId);
        default:
          throw new Error(`Unknown item type: ${itemType}`);
      }
    });
    return Promise.all(promises);
  }
};

export default calendarApi;
